
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    WEDGEPLAY_ACTION,
    ALL_WEDGEPLAY,
    ADD_WEDGEPLAY,
    FETCH_WEDGEPLAY,
    EDIT_WEDGEPLAY,
    DELETE_WEDGEPLAY
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * FS IRONS Actions
 */

    export const allWedgeplay = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: WEDGEPLAY_ACTION });
            return axios.get(AppConfig.apiurl+'/api/gettqnewwedgeplay', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_WEDGEPLAY, payload: alldata });
            });
        }        
    
    }

    export const addWedgeplay = (data, cntcry, cntclub, cntball, cntrate, cntloft, cntdynamic, cntlaunch, cntlanding) =>{
    
        var payload={
            "student":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "selclub":data.target.selclub.value,
            "notes":data.target.notes.value,
        }
        
        var cryarr=[];
        for(let i = 0; i<cntcry; i++) {  
            var sepday='carry_'+i;            
            var sedyval=data.target[sepday].value;
            cryarr.push(sedyval);
        }

        var clubarr=[];
        for(let i = 0; i<cntclub; i++) {  
            var sepday='clubspeed_'+i;            
            var sedyval=data.target[sepday].value;
            clubarr.push(sedyval);
        }

        var ballarr=[];
        for(let i = 0; i<cntball; i++) {  
            var sepday='ballspeed_'+i;            
            var sedyval=data.target[sepday].value;
            ballarr.push(sedyval);
        }

        var ratearr=[];
        for(let i = 0; i<cntrate; i++) {  
            var sepday='spinrate_'+i;            
            var sedyval=data.target[sepday].value;
            ratearr.push(sedyval);
        }

        var loftarr=[];
        for(let i = 0; i<cntloft; i++) {  
            var sepday='spinloft_'+i;            
            var sedyval=data.target[sepday].value;
            loftarr.push(sedyval);
        }

        var dynamicarr=[];
        for(let i = 0; i<cntdynamic; i++) {  
            var sepday='dynamicloft_'+i;            
            var sedyval=data.target[sepday].value;
            dynamicarr.push(sedyval);
        }

        var launcharr=[];
        for(let i = 0; i<cntlaunch; i++) {  
            var sepday='launchangle_'+i;            
            var sedyval=data.target[sepday].value;
            launcharr.push(sedyval);
        }

        var landarr=[];
        for(let i = 0; i<cntlanding; i++) {  
            var sepday='landingangle_'+i;            
            var sedyval=data.target[sepday].value;
            landarr.push(sedyval);
        }

        var carry=cryarr.join(",");
        var club=clubarr.join(",");
        var ball=ballarr.join(",");
        var rate=ratearr.join(",");
        var loft=loftarr.join(",");
        var dynamic=dynamicarr.join(",");
        var launch=launcharr.join(",");
        var landing=landarr.join(",");
        payload["carry"]=carry;   
        payload["clubspeed"]=club;   
        payload["ballspeed"]=ball;   
        payload["spinrate"]=rate;   
        payload["spinloft"]=loft;   
        payload["dynamicloft"]=dynamic;   
        payload["launchangle"]=launch;   
        payload["landingangle"]=landing;        

        return (dispatch) => { 
            dispatch({ type:WEDGEPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addtqnewwedgeplay', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allWedgeplay()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_WEDGEPLAY});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchWedgeplay = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:WEDGEPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/fetchtqnewwedgeplay', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_WEDGEPLAY, payload: resdata.data[0]});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editWedgeplay = (data, id, cntcry,  cntclub, cntball, cntrate, cntloft, cntdynamic, cntlaunch, cntlanding) =>{
    
        var payload={
            "id":id,
            "student":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "selclub":data.target.selclub.value,
            "notes":data.target.notes.value,
        }

        var cryarr=[];
        for(let i = 0; i<cntcry; i++) {  
            var sepday='carry_'+i;            
            var sedyval=data.target[sepday].value;
            cryarr.push(sedyval);
        }

        var clubarr=[];
        for(let i = 0; i<cntclub; i++) {  
            var sepday='clubspeed_'+i;            
            var sedyval=data.target[sepday].value;
            clubarr.push(sedyval);
        }

        var ballarr=[];
        for(let i = 0; i<cntball; i++) {  
            var sepday='ballspeed_'+i;            
            var sedyval=data.target[sepday].value;
            ballarr.push(sedyval);
        }

        var ratearr=[];
        for(let i = 0; i<cntrate; i++) {  
            var sepday='spinrate_'+i;            
            var sedyval=data.target[sepday].value;
            ratearr.push(sedyval);
        }

        var loftarr=[];
        for(let i = 0; i<cntloft; i++) {  
            var sepday='spinloft_'+i;            
            var sedyval=data.target[sepday].value;
            loftarr.push(sedyval);
        }

        var dynamicarr=[];
        for(let i = 0; i<cntdynamic; i++) {  
            var sepday='dynamicloft_'+i;            
            var sedyval=data.target[sepday].value;
            dynamicarr.push(sedyval);
        }

        var launcharr=[];
        for(let i = 0; i<cntlaunch; i++) {  
            var sepday='launchangle_'+i;            
            var sedyval=data.target[sepday].value;
            launcharr.push(sedyval);
        }

        var landarr=[];
        for(let i = 0; i<cntlanding; i++) {  
            var sepday='landingangle_'+i;            
            var sedyval=data.target[sepday].value;
            landarr.push(sedyval);
        }

        var carry=cryarr.join(",");
        var club=clubarr.join(",");
        var ball=ballarr.join(",");
        var rate=ratearr.join(",");
        var loft=loftarr.join(",");
        var dynamic=dynamicarr.join(",");
        var launch=launcharr.join(",");
        var landing=landarr.join(",");
        payload["carry"]=carry;   
        payload["clubspeed"]=club;   
        payload["ballspeed"]=ball;   
        payload["spinrate"]=rate;   
        payload["spinloft"]=loft;   
        payload["dynamicloft"]=dynamic;   
        payload["launchangle"]=launch;   
        payload["landingangle"]=landing;


        return (dispatch) => { 
            dispatch({ type:WEDGEPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/edittqnewwedgeplay', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allWedgeplay()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_WEDGEPLAY});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


    export const deleteWedgeplay = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:WEDGEPLAY_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deletetqnewwedgeplay', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allWedgeplay()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_WEDGEPLAY});                    
                }                
                
            });
        
        }
    }


   

